export const profileData = {
  id: 875,
  email: "john.doe@example.com",
  firstName: "John",
  lastName: "Doe",
  preferredLocale: "en",
  rememberToken: "98aa2d03a00e404718d8189612fe274c",
  status: "COMPLETE",
  telephone: "00966500000068",
  tposBranch: {
    addressDescription: "Al-Baik BFX POSist lab",
    city: "Jeddah",
    id: 107,
    isOpen: true,
    latitude: 21.5615979,
    longitude: 39.2234012,
    name: "POSist test lab",
    deliveryMethods: ["home_delivery", "offline_drive_thru", "pickup"],
    supportsPickupCustomerArrivalFlow: true,
    hasCustomMenu: true,
    acceptingInStoreOrders: true,
    acceptingCurbsideOrders: true,
    hasCustomPricingForDelivery: false,
    showSosNumberInAlbaikApp: true,
    curbsideExpectedBranchDelayMinutes: 5,
    pickupPreparationTimeStrategy: "basket_total",
    estimatedWaitingTime: 10,
    licensee: {
      id: 1,
      code: "EFC",
      name: "Express Food Company",
      vat: "4000000000",
      commercialRegistration: "500000000",
    },
    openingHours: [
      {
        closesAt: 240,
        opensAt: 360,
      },
    ],
  },
};
